(function () {
  "use strict";

  function init() {
    // move popup right after start of body tag
    // cuz #PageContainer has transform css property, it messes with the popup's fixed position
    const body = document.body;
    const popup = document.querySelector(".product-compare-group__popup");
    if (body && popup) {
      body.prepend(popup);
    }

    // if screen resized to below 1024px, remove class from the popup
    window.addEventListener("resize", function () {
      if (window.innerWidth < 1024) {
        popup?.classList.remove("active");
      }
    });
  }

  function handleButtonClick() {
    const button = document.querySelector(".product-compare-group__button");
    if (!button) return;
    button.addEventListener("click", function () {
      document
        .querySelector(".product-compare-group__popup")
        ?.classList.add("active");
    });
  }

  function handleCloseButtonClick() {
    const button = document.querySelector(".product-compare-group__close");
    if (!button) return;
    button.addEventListener("click", function () {
      this.closest(".product-compare-group__popup")?.classList.remove("active");
    });
  }

  function handleGroupSelectClick() {
    const groupItems = document.querySelectorAll(
      ".product-compare-group__container-item"
    );
    groupItems.forEach((group) => {
      const select = group.querySelector(".product-compare-group__item-select");
      const options = group.querySelectorAll(
        ".product-compare-group__item-option "
      );
      const groupProducts = group.querySelectorAll(
        ".product-compare-group__item-product"
      );
      const groupInfos = group.querySelectorAll(
        ".product-compare-group__item-info-container"
      );

      select.addEventListener("click", function () {
        this.classList.toggle("open");
      });

      options.forEach((option) => {
        option.addEventListener("click", function () {
          options.forEach((option) => option.classList.remove("selected"));
          this.classList.add("selected");

          select.querySelector(
            ".product-compare-group__item-trigger"
          ).textContent = this.textContent;

          const blockId = this.dataset.blockId;
          const list = [groupProducts, groupInfos];
          list.forEach((x) => {
            x.forEach((y) => {
              y.classList.remove("active");

              if (y.dataset.blockId == blockId) {
                y.classList.add("active");
              }
            });
          });
        });
      });
    });
  }

  function handleProductOptionClick() {
    const products = document.querySelectorAll(
      ".product-compare-group__item-product"
    );
    products.forEach((product) => {
      const images = product.querySelectorAll(
        ".product-compare-group__item-product-images img"
      );
      const buttons = product.querySelectorAll(
        ".product-compare-group__item-product-options button"
      );
      const prices = product.querySelectorAll(
        ".product-compare-group__item-product-price"
      );
      const ctas = product.querySelectorAll(
        ".product-compare-group__item-product-cta"
      );
      buttons.forEach((button) => {
        button.addEventListener("click", function () {
          buttons.forEach((button) => button.classList.remove("selected"));
          this.classList.add("selected");

          const index = this.dataset.index;
          const list = [images, prices, ctas];
          list.forEach((x) => {
            x.forEach((y, i) => {
              y.classList.remove("active");
              if (i == index) {
                y.classList.add("active");
              }
            });
          });
        });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run, { once: true });
  } else {
    run();
  }

  function run() {
    init();
    handleButtonClick();
    handleCloseButtonClick();
    handleGroupSelectClick();
    handleProductOptionClick();
  }
})();
